module.exports = __webpack_public_path__ + "img/bg_change_icon.43b9d254.svg";